import { Component, effect, inject, model, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ConfigMail } from './config-mail.interface';
import { finalize, forkJoin } from 'rxjs';
import { ConfigMailsService } from './config-mails.service';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, ReactiveFormsModule, } from '@angular/forms';
import { ChipsModule } from 'primeng/chips';
import { AutoCompleteModule } from 'primeng/autocomplete';

export type MailType = 'pending_branches_today' | 'closing_discrepancies';

@Component({
    selector: 'mails-modal',
    standalone: true,
    imports: [DialogModule, ButtonModule, ReactiveFormsModule, ChipsModule, AutoCompleteModule],
    templateUrl: './mails-modal.component.html',
})
export class MailsModalComponent {

    private fb = inject(FormBuilder);

    isLoading = signal(false);
    savingData = signal(false);
    visible = model(false);
    configMails = signal<ConfigMail[]>([])
    private configMailService = inject(ConfigMailsService);
    private messageService = inject(MessageService);

    form: FormGroup = this.fb.group({
        pending_branches_today: [[]],
        closing_discrepancies: [[]]
    });


    constructor() {
        effect(() => {
            if (this.visible()) {
                this.loadData();
            }
        });
    }

    loadData() {
        this.isLoading.set(true);
        this.configMailService.getMails()
            .pipe(finalize(() => this.isLoading.set(false)))
            .subscribe({
                next: (res) => {
                    res.data.forEach(config => {
                        if (this.form.controls[config.type]) {
                            this.form.controls[config.type].setValue(config.emails);
                        }
                    });
                },
                error: () => this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No se pudieron cargar los correos'
                })
            });
    }


    save() {
        if (this.form.invalid) return;

        this.savingData.set(true);

        const requests = Object.keys(this.form.value).map(type =>
            this.configMailService.saveMails(type as MailType, this.form.value[type])
        );

        forkJoin(requests)
            .pipe(finalize(() => this.savingData.set(false)))
            .subscribe({
                next: (response) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Guardado',
                        detail: 'Configuración actualizada correctamente'
                    });
                    this.hideDialog();
                },
                error: () => this.hideDialog()
            });

    }

    hideDialog() {
        this.visible.set(false);
        this.form.reset();
    }

}
